import React, { useEffect, useRef, useState } from "react";
import styled from 'styled-components'
import MainBG from './imgs/main-bg@2x.png';
import AwardTitle from './imgs/award-title@2x.png';
import Award1 from './imgs/award1@2x.png';
import Award2 from './imgs/award2@2x.png';
import Award3 from './imgs/award3@2x.png';
import RaffleTip from './imgs/accumulate-icon@2x.png';
import NoJoinImg from './imgs/no-join@2x.png';
import RaffleBtn from './imgs/raffle-btn@2x.png'
import LuckyGrid from './lucky-grid';
import bridge from '@/config/JSbridge'
import ModalView from '@/components/modal-view'
import { Toast } from 'antd-mobile'
import Header from '@/components/Header'
import { jumpTo } from '@/utils'
import AwardModal from './award-modal'
import bwmodel from '@/config/bwmodel'
import { fetchDrawTimes, fetchDraw, fetchAwardInfo, fetchWithdrawBonus, fetchRaffleInfo, fetchDonateStatus, fetchTransfer, recoverComptition } from './api'

const Activity210 = () => {
  const luckyRef = useRef()
  const [withdrawCount, setWithdrawCount] = useState(0);  // 提取金额
  const [awardInfo, setAwardInfo] = useState({ point: 0, vip: 0, amount: 0 });   // 奖品数量
  const [drawInfo, setDrawInfo] = useState({ leftCount: 0, status: 1 });          // 可获得抽奖次数
  const [raffleInfo, setRaffleInfo] = useState({});   // 可抽奖次数
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(1);
  const [transferAmount, setTransferAmount] = useState(0);  // 提取成功金额
  const [showTipModal, setShowTipModal] = useState(false);
  const awardModalRef = useRef()
  const isRaffling = useRef(false);

  useEffect(() => {
    getDrawTimes();
    getAwardInfo();
    getWithDrawData();
    getRaffleInfo();

    bridge.addRegisterHandler([
      {
        name: 'viewWillAppear',
        callback: (res) => {
          setTimeout(() => {
            getDrawTimes();
            getRaffleInfo();
          }, 500)
        }
      },
    ])
  }, [])

  const getDrawTimes = () => {
    fetchDrawTimes().then(res => {
      setDrawInfo(res)
    });
  }

  const getWithDrawData = () => {
    fetchWithdrawBonus({ activityId: 230 }).then(res => {
      setWithdrawCount(res.withdrawableBonus || 0);
    })
  }

  const getRaffleInfo = () => {
    fetchRaffleInfo({ activityId: 230 }).then(res => {
      setRaffleInfo(res.data || {});
    })
  }

  const getAwardInfo = () => {
    fetchAwardInfo({ activityId: 230 }).then(res => {
      let result = { point: 0, vip: 0, amount: 0 };
      const totalAwardList = res.totalAwardList || [];
      totalAwardList.forEach(item => {
        if (item.awardType === 0) {
          result.point = item.awardNum || 0;
        }
        if (item.awardType === 1) {
          result.vip = item.awardNum || 0;
        }
        if (item.awardType === 18) {
          result.amount = item.awardAmount|| 0;
        }
      })
      setAwardInfo(result)
    })
  }

  const handleDraw = () => {
    if (isRaffling.current) {
      return;
    }
    if (drawInfo.status === 2) {
      Toast.info('你已被限制参与，如有疑问可前往「意见反馈」中咨询')
      return
    }
    const availableCount = raffleInfo.availableCount || 0
    if (availableCount <= 0) {
      Toast.info('无抽奖次数，请去完成任务获取')
      return
    }
    isRaffling.current = true;
    fetchDraw({activityId: 230}).then(res => {
      if (res.errors) {
        isRaffling.current = false;
        return
      }
      const awardIdx = getRaffleStep(res.award)
      
      luckyRef.current.start(awardIdx, () => {
        const awardText = getAwardText(res.award);
        const isRed = res.award.awardType === 18;
        awardModalRef.current.show(awardText, isRed)
        isRaffling.current = false;
      })
    }).catch(err => {
      isRaffling.current = false;
    })
  }

  const handleAwardClose = () => {
    getRaffleInfo()
    getAwardInfo()
    getWithDrawData()
  }

  const getAwardText = (res) => {
    if (res.awardType === 0) {
      return `${res.awardNum}积分`
    }
    if (res.awardType === 1) {
      return `${res.awardNum}天风云VIP`
    }
    if (res.awardType === 18) {
      return res.name
    }
  }

  const getRaffleStep = (res) => {
    const { awardNum, awardType, parentAwardType } = res;
    if (awardType === 0) {
      // 抽中积分
      if (awardNum === 8) {
        return 0
      }
      if (awardNum === 66) {
        return 3
      }
    }
    if (awardType === 1) {
      // 抽中vip天数
      if (awardNum === 1) {
        return 2
      }
      if (awardNum === 3) {
        return 5
      }
    }
    if (awardType === 18) {
      // 抽中现金红包
      if (parentAwardType === 16) {
        return 4
      }
      if (parentAwardType === 17) {
        return 1
      }
    }
  }

  const handleClick = (e) => {
    handleDraw()
  }

  const handleSendClick = () => {
    if (!bwmodel.compareVersion('6.54.0')) {
      Toast.info('请更新到最新版本参与')
      return
    }
    if (drawInfo.status === 2) {
      Toast.info('你已被限制参与，如有疑问可前往「意见反馈」中咨询')
      return
    }
    bridge.callHandler('nativeEvent', {
      event: 'openPublishForumEvent',
      params: {
        text: '',
      }
    }, res => {
    })
  }

  const handleInvoke = async () => {
    if (drawInfo.status === 2) {
      Toast.info('你已被限制参与，如有疑问可前往「意见反馈」中咨询')
      return
    }
    try {
      const res1 = await fetchDonateStatus()
      if (res1.activateDonate === 0) {
        setModalType(1)
        setShowModal(true);
        return
      }
      if (Number(withdrawCount) < 1) {
        Toast.info('金额需大于1元才能提取')
        return
      }
      const res2 = await fetchTransfer({ activityId: 230, amount: withdrawCount})
      setTransferAmount(res2.amount)
      setModalType(2)
      setShowModal(true);
      getWithDrawData()
    } catch (error) {
      
    }
    
  }

  const handleLookAccount = () => {
    window.location.href = 'storm://app/donate/accounthome'
  }

  const handleOpenDonate = () => {
    window.location.href = 'storm://app/donate/openDonate'
  }

  const handleLeftClick = () => {
    bridge.callHandler('nativeEvent', {event: 'close', params: {
      isDelete: false
    }}, () => {})
  }

  const handleShowRaffleDetail = () => {
    jumpTo(`/active_230/raffle`);
  }

  const handleShowAwardDetail = () => {
    jumpTo(`/active_230/award`);
  }

  const handleRuleClick = () => {
    jumpTo(`/active_230/rule`);
  }

  const getModalContent = () => {
    if (modalType === 1) {
      return (
        <div className="modal-wrap">
          <div className="modal-title">提示</div>
          <div className="modal-desc">提取到账户需开通「赞赏功能」</div>
          <div className="modal-btns">
            <div className="cancel-btn modal-btn" onClick={() => setShowModal(false)}>取消</div>
            <div className="confirm-btn modal-btn" onClick={handleOpenDonate}>前往开通</div>
          </div>
        </div>
      )
    }

    if (modalType === 2) {
      return (
        <div className="modal-wrap">
          <div className="modal-title">提示</div>
          <div className="modal-desc">{Number(transferAmount).toFixed(2)}元已成功提取到账户</div>
          <div className="modal-btns">
            <div className="cancel-btn modal-btn" onClick={() => setShowModal(false)}>取消</div>
            <div className="confirm-btn modal-btn" onClick={handleLookAccount}>去账户查看</div>
          </div>
        </div>
      )
    }

    if (modalType === 3) {
      return (
        <div className="modal-wrap">
          <div className="modal-title">提示</div>
          <div className="modal-desc">明日12点还未参与活动，我们会发送通知进行告知，请注意打开“消息通知”以免错过</div>
          <div className="modal-btns">
            <div className="confirm-btn modal-btn" onClick={() => setShowModal(false)}>知道了</div>
          </div>
        </div>
      )
    }
  }

  const handleRallfeTip = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowTipModal(true);
  }

  const handleRecover = () => {
    recoverComptition({ activityId: 230 }).then(res => {
      Toast.info('已恢复参与活动')
      getDrawTimes()
    })
  }

  const handleAwardTip = () => {
    setModalType(3)
    setShowModal(true);
  }

  return (
    <Container>
      <Header
        title={'每日发帖抽红包'}
        leftClick={()=> {
          handleLeftClick()
        }}
        right={<span onClick={handleRuleClick} className="right-text">活动规则</span>}
      />
      <div className="content-bg">
        <img className="raffle-btn" src={RaffleBtn} alt="" onClick={handleClick}/>
        <div className="luckgrid-container">
          <LuckyGrid ref={luckyRef} />
        </div>
        <div className="raffel-info">
          <div className="raffel-times">剩余次数：<span className="raffle-count">{raffleInfo.availableCount || 0}</span> 次</div>
          <div className="raffel-text">
            <span>累计抽99次，保底抽中大红包！</span>
            <span className="raffel-use">（已累计<span className="raffel-use-text">{raffleInfo.factorDrawCount || 0}</span>次）<img onClick={handleRallfeTip} className="raffle-tip" src={RaffleTip} alt=""/></span>
          </div>
        </div>
        <div className="active-content">
          <div className="reward-content">
            {drawInfo.status === 1 && drawInfo.leftCount > 0 && (
              <div className="award-item award-item1">
                <div className="award-label">今日还可获得{drawInfo.leftCount}次抽奖次数</div>
                <div className="publish-btn" onClick={handleSendClick}>去发帖</div>
              </div>
            )}
            {drawInfo.status === 1 && drawInfo.leftCount === 0 && (
              <div className="award-item award-item1">
                <div className="award-label">
                  <div>今日抽奖次数已获取，明日还可获2次</div>
                  <div className="award-label-tip" onClick={handleAwardTip}>（明日会提醒你）</div>
                </div>
              </div>
            )}

            {drawInfo.status === 3 && (
              <div className="award-item award-item1">
                <div className="award-label">你关闭了获取抽奖次数，不会再增加次数</div>
                <div className="publish-btn" onClick={handleRecover}>继续参与</div>
              </div>
            )}

            {drawInfo.status === -1 && (
              <div className="award-item award-item4">
                <div className="no-join-wrap"><img alt="" src={NoJoinImg} className="no-join" /></div>
                <div className="no-join-text">不满足参与条件</div>
                <div className="no-join-desc">可连续再<span className="no-join-days">登录{drawInfo.loginDaysRequired}天</span>后再来尝试</div>
              </div>
            )}

            {[1, 2, 3].includes(drawInfo.status) && (
              <div>
                <div className="award-item award-item2">
                  <div className="award-label">可提取红包</div>
                  <div className="flex-between">
                    <div className="amount">
                      <span>{Number(withdrawCount).toFixed(2)}</span>
                      <span className="amount-unit">元</span>
                    </div>
                    <div className="withdraw-btn" onClick={handleInvoke}>提取到账户</div>
                  </div>
                  <div className="award-tips">
                    <div>红包30天内未提取将会过期清除，请及时提取；</div>
                    <div>提取到账户后可提现。</div>
                  </div>
                </div>
                <div className="award-item award-item3">
                  <div className="flex-center"><img src={AwardTitle} alt="" className="award-title"/></div>
                  <div className="flex-between bonus-box">
                    <div className="bonus-item">
                      <div className="award-img-wrap"><img src={Award1} className="award-img" alt=""/></div>
                      <div className="award-content">{awardInfo.amount}元</div>
                    </div>
                    <div className="bonus-item">
                      <div className="award-img-wrap"><img src={Award2} className="award-img" alt=""/></div>
                      <div className="award-content">{awardInfo.vip}天风云VIP</div>
                    </div>
                    <div className="bonus-item">
                      <div className="award-img-wrap"><img src={Award3} className="award-img" alt=""/></div>
                      <div className="award-content">{awardInfo.point}积分</div>
                    </div>
                  </div>
                  <div className="award-split"></div>
                  <div className="award-actions flex-between">
                    <div className="award-detail" onClick={handleShowRaffleDetail}>抽奖次数明细 {'>'}</div>
                    <div className="award-detail" onClick={handleShowAwardDetail}>获得奖励明细 {'>'}</div>
                  </div>
                </div>
              </div>
            )}

            
          </div>
        </div>
        <div className="active-tips">本活动与Apple Inc无关</div>
      </div>
      <ModalView
        visible={showModal}
        content={
          <ModalCard>
            {getModalContent()}
          </ModalCard>
        }
      />
      <ModalView
        visible={showTipModal}
        content={
          <ModalCard>
            <div className="modal-wrap">
              <div className="modal-title">累计抽奖次数说明</div>
              <div className="modal-desc tip-desc">
                <div className="desc-item">累计抽奖次数会在每次参与抽奖后累加，当连续抽98次还未抽取到奖池中的大红包时，第99次抽必得“大红包”。</div>
                <div className="desc-item">累计次数清零：抽取到“大红包”奖品后，累计抽奖次数将被清零；</div>
                <div className="desc-item">累计次数衰减：当累计抽奖次数超过20次后，近5天未再参与抽奖时，累计抽奖次数将减少2次。</div>
              </div>
              <div className="modal-btns tip-btns">
                <div className="confirm-btn modal-btn tip-btn" onClick={() => setShowTipModal(false)}>我知道了</div>
              </div>
            </div>
          </ModalCard>
        }
      />
      <AwardModal ref={awardModalRef} onClose={handleAwardClose} />
    </Container>
  )
}

export default Activity210;

const ModalCard = styled.div`
  padding: 0 55px;
  width: 100%;
  .modal-wrap {
    background: #FFFFFF;
    border-radius: 14px;
    backdrop-filter: blur(15px);
    padding: 20px 16px;
  }
  .modal-title {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    line-height: 22px;
    text-align: center;
  }
  .modal-desc {
    text-align: center;
    margin-top: 16px;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    line-height: 18px;
  }
  .cancel-btn {
    border: 2px solid #F3F4F9;
    margin-right: 12px;
  }
  .desc-item {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .modal-btns {
    display: flex;
    margin-top: 20px;
  }
  .modal-btn {
    flex: 1;
    height: 36px;
    border-radius: 20px;
    font-weight: 500;
    font-size: 14px;
    color: #9696A6;
    line-height: 36px;
    text-align: center;
    box-sizing: border-box;
  }
  .tip-btns {
    justify-content: center;
  }
  .tip-btn {
    flex: unset;
    width: 118px;
    background: #FF2848;
    color: #fff;
  }
  .confirm-btn {
    background: #FF2848;
    color: #fff;
  }
`;


const Container = styled.div`
  padding-top: 44px;
  font-family: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif;
  .right-text {
    font-weight: 400;
    font-size: 15px;
    color: #293241;
    line-height: 21px;
  }
  .content-bg {
    background-image: url(${MainBG});
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-color: #FF7676;
    position: relative;
  }
  .luckgrid-container {
    width: 100%;
    position: absolute;
    left: 0;
    top: 58vw;
    box-sizing: border-box;
    padding: 0 15vw 0 16vw;
  }
  .active-content {
    padding-top: 147vw;
  }
  .raffle-btn {
    width: 44.6vw;
    position: absolute;
    top: 113vw;
    left: 27.7vw
  }
  .reward-content {
    background-color: #FFFFFF;
    border-radius: 0px 0px 16px 16px;
    width: 76.5vw;
    margin: 0 auto;
    padding: 20px 12px 12px;
    background-image: linear-gradient(180deg, #FFC0C1 0px, #FFFFFF 6px);
  }
  .award-item4 {
    text-align: center;
    padding: 11px 0 18px;
    .no-join {
      wisth: 66px;
      height: 66px;
    }
    .no-join-text {
      font-weight: 500;
      font-size: 18px;
      color: #293241;
      line-height: 25px;
      margin-top: 4px;
    }
    .no-join-desc {
      font-weight: 400;
      font-size: 15px;
      color: #9696A6;
      line-height: 21px;
      margin-top: 6px;
    }
    .no-join-days {
      color: #FF2848;
    }
  }

  .award-item {
    background: #FEF3E9;
    border-radius: 8px;
    padding-left: 12px;
    padding-right: 12px;
    margin-bottom: 10px;
  }
  .award-item1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 12px;
    .award-label-tip {
      font-weight: 400;
      font-size: 12px;
      color: #9696A6;
      line-height: 17px;
      margin-top: 4px;
    }
  }
  .award-item2 {
    padding-top: 17px;
    padding-bottom: 16px;
    .amount {
      font-weight: 500;
      font-size: 32px;
      color: #293241;
      line-height: 45px;
    }
    .amount-unit {
      font-weight: 500;
      font-size: 12px;
      color: #293241;
      line-height: 17px;
      margin-left: 3px;
    }
    .withdraw-btn {
      width: 90px;
      height: 30px;
      background: linear-gradient( 135deg, #FF7E69 0%, #FF2E2E 100%);
      border-radius: 20px;
      font-weight: 500;
      font-size: 13px;
      color: #FFFFFF;
      line-height: 18px;
      text-align: center;
      line-height: 30px;
    }
    .award-tips {
      font-weight: 400;
      font-size: 10px;
      color: #9696A6;
      line-height: 14px;
      margin-top: 10px;
      text-align: center;
    }
  }

  .award-item3 {
    padding-top: 11px;
    padding-bottom: 10px;
    padding-left: 0;
    padding-right: 0;
    .award-title {
      width: 142px;
      height: 27px;
      margin: 0 auto;
    }
    .bonus-box {
      margin-top: 10px;
      padding: 0 12px;
      .bonus-item {
        height: 86px;
        flex: 1;
        margin-right: 10px;
        background: #FFFFFF;
        border-radius: 20px;
        overflow: hidden;
        &:last-child {
          margin-right: 0px;
        }
      }
    }
    .award-img-wrap {
      display: flex;
      justify-content: center;
      padding-top: 14px;
    }
    .award-img {
      width: 36px;
      height: 36px;
    }
    .award-content {
      margin-top: 12px;
      height: 24px;
      background: #FFE5CE;
      font-weight: 500;
      font-size: 10px;
      color: #FF5F52;
      line-height: 20px;
      text-align: center;
    }
    .award-split {
      height: 0px;
      border-top: 1px dashed #FFD5AF;
      margin-top: 16px;
      margin-bottom: 10px;
    }
    .award-actions {
      padding: 0 12px;
    }
    .award-detail {
      height: 32px;
      flex: 1;
      background: #F2B47A;
      border-radius: 12px;
      margin-right: 8px;
      text-align: center;
      font-weight: 500;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 32px;

      &:last-child {
        margin-right: 0px;
      }
    }
  }

  .award-label {
    font-weight: 400;
    font-size: 13px;
    color: #293241;
    line-height: 18px;
  }
  .publish-btn {
    width: 64px;
    height: 26px;
    border-radius: 20px;
    border: 1px solid #FF2848;
    font-weight: 500;
    line-height: 22px;
    font-size: 13px;
    color: #F12421;
    text-align: center;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  .active-tips {
    font-weight: 400;
    font-size: 10px;
    color: #FFFFFF;
    line-height: 14px;
    text-align: center;
    padding: 12px 0 14px;
  }

  .raffel-info {
    text-align: center;
    margin-bottom: 16px;
    position: absolute;
    width: 100%;
    left: 0;
    top: 129vw;
  }
  .raffel-times {
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 17px;
    .raffle-count {
      color: #FEE880;
    }
  }
  .raffel-text {
    font-weight: 400;
    font-size: 12px;
    color: #FEE880;
    line-height: 24px;
    background: #CA0A06;
    margin: 9px 26px 0;
    height: 24px;
    border-radius: 8px;
    .raffle-tip {
      width: 12px;
      height: 12px;
      position: relative;
      top: 2px;
    }
  }
  .raffel-use {
    color: #FFFFFF;
  }
  .raffel-use-text {
    color: #FEE880;
  }
`